import React from "react";
import { getBenchLabel } from "util/meetHelper";
import Table, { Column } from "components/table/Table";
import AttemptCell from "./cells/AttemptCell";

import { useMeet } from "util/useMeet";
import { useMediaSize } from "util/useMediaSize";

import TotalCell from "./cells/TotalCell";
import DefaultTextCell from "components/cells/DefaultTextCell";
import PointsCell from "./cells/PointsCell";
import { useFedConfig } from "util/useFedConfig";
import compact from "lodash/compact";

const getCellLines = () => {
  return 1;
};

const TeamTable = ({ data }: { data: any }) => {
  const meet = useMeet();
  const media = useMediaSize();
  const federationConfig = useFedConfig();

  const getAllColumns = (): Column[] => {
    const showFourthAttempts = !!federationConfig?.fourthAttempts;
    // prettier-ignore
    return compact([
      {key: 'name', label: 'Name', width: 220, renderer: DefaultTextCell},
      meet.hideTeamScoring ? undefined: {key: 'teamPointsContributed', label: 'Points', width: 85, renderer: PointsCell},
      {key: 'place', label: 'Place', width: 55, renderer: DefaultTextCell},
      {key: 'weight', label: 'Squat 1', width: 70, lift: 'squat', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: 'Squat 2', width: 70, lift: 'squat', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: 'Squat 3', width: 70, lift: 'squat', attemptNumber: '3', renderer: AttemptCell},
      showFourthAttempts ? {key: 'squat.4.weight', label: 'Squat 4', width: 70, lift: 'squat', attemptNumber: '4', renderer: AttemptCell} : undefined,
      {key: 'weight', label: `${getBenchLabel(meet)} 1`, width: 70, lift: 'bench', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(meet)} 2`, width: 70, lift: 'bench', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(meet)} 3`, width: 70, lift: 'bench', attemptNumber: '3', renderer: AttemptCell},
      showFourthAttempts ? {key: 'bench.4.weight', label: `${getBenchLabel(meet)} 4`, width: 70, lift: 'bench', attemptNumber: '4', renderer: AttemptCell} : undefined,
      {key: 'weight', label: 'Dead 1', width: 70, lift: 'dead', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 2', width: 70, lift: 'dead', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 3', width: 70, lift: 'dead', attemptNumber: '3', renderer: AttemptCell},
      showFourthAttempts ? {key: 'dead.4.weight', label: 'Dead 4', width: 70, lift: 'squat', attemptNumber: '4', renderer: AttemptCell} : undefined,
      {key: 'division.name', label: 'Primary Division', width: 165, renderer: DefaultTextCell},
      {key: 'weightClass', label: 'Wgt Cls', width: 65, renderer: DefaultTextCell},
      {key: 'total', label: 'Total', width: 80, renderer: TotalCell},

    ]);
  };

  const columns = getAllColumns();

  return (
    <Table
      data={data}
      numberOfFixedLeftColumns={1}
      columns={columns}
      getCellLines={getCellLines}
      meet={meet}
      scrollToAlignment="center"
      media={media}
      padBottom
    />
  );
};

export default TeamTable;
